// import { Entity, EntityConstructorParams, Hub, Interactable, RaycastTargetCircle } from '@movya-oy/storyverse-core';

// couldn't find typings for troika
// @ts-ignore
import { filter } from 'rxjs';
import { BufferGeometry, Camera, CircleGeometry, Color, Group, Material, MathUtils, Mesh, MeshBasicMaterial, NormalBufferAttributes, Object3D, Object3DEventMap, PositionalAudio, Quaternion, RingGeometry, SphereGeometry, Vector3 } from 'three';
import { EasingFunction } from './easing-utils';
import { addDepthOverride } from './material-utils';
import { Button } from './button';
import { BasicSpot } from './basic-spot';


// use external arrow mesh
export class ArrowSpot extends BasicSpot {

  protected _upArrow: Mesh;
  protected _downArrow: Mesh;

  protected _highlightTarget?: Object3D;

  protected _touchDistance: number = 0.05;

  private _arrowUpAnimation = {
    targeted: false,
    phase: 0,
    easedPhase: 0,
  };

  private _arrowDownAnimation = {
    targeted: false,
    phase: 0,
    easedPhase: 0,
  };

  // declare hoverAnimation: { targeted: boolean; phase: number; easedPhase: number; speed: number; easing: (t: number) => number; minScale: Vector3; maxScale: Vector3; };

  constructor(arrowParent: Object3D) {
    super();
    // this._dot = new Object3D();
    // this._arrowObject = arrowParent;
    // this._meshContainer.add(arrowMesh);
    this._dot?.removeFromParent();
    this._ring?.removeFromParent();
    this._dotXray?.removeFromParent();
    this._ringXray?.removeFromParent();
    this._upArrow = arrowParent.getObjectByName('Arrow_Up') as Mesh;
    this._downArrow = arrowParent.getObjectByName('Arrow_Down') as Mesh;

    this._upArrow.position.set(0, 0, 0);
    this._downArrow.position.set(0, 0, 0);
    // arrowMesh.position.set(0, 0, 0);
    this._touchAreaIndicator.scale.setScalar(this._touchDistance*10)

  }

  update(cameraMiddle: Vector3, dt: number): void {
    this._meshContainer.lookAt(cameraMiddle);
    this.updateGraphicsScale(dt);
  }

  playAnimation(direction: "up" | "down") {
    // this.isTouched = true;
    if (direction === "up") {
      this._arrowUpAnimation.targeted = true;
      this.playToggleSound(true);
    } else {
      this._arrowDownAnimation.targeted = true;
      this.playToggleSound(false);
    }
  }

  private _arrowMovement = 0.05;

  private _arrowSpacing = 0.02;
  
  updateGraphicsScale(delta: number) {

    // no idea where the ia name came from
    const ia = this.hoverAnimation;

    const arrowUpAnimation = this._arrowUpAnimation;
    const arrowDownAnimation = this._arrowDownAnimation;

    arrowUpAnimation.phase += (arrowUpAnimation.targeted ? 1 : -1) * delta * ia.speed;
    arrowUpAnimation.phase = MathUtils.clamp(arrowUpAnimation.phase, 0, 1);
    arrowUpAnimation.easedPhase = ia.easing(arrowUpAnimation.phase);

    arrowDownAnimation.phase += (arrowDownAnimation.targeted ? 1 : -1) * delta * ia.speed;
    arrowDownAnimation.phase = MathUtils.clamp(arrowDownAnimation.phase, 0, 1);
    arrowDownAnimation.easedPhase = ia.easing(arrowDownAnimation.phase);

    if (arrowUpAnimation.phase >= 1){
      arrowUpAnimation.targeted = false;
    }
    if (arrowDownAnimation.phase >= 1){
      arrowDownAnimation.targeted = false;
    }

    // this._upArrow.scale.lerpVectors(ia.minScale, this._arrowMaxScale, arrowUpAnimation.easedPhase);
    // this._downArrow.scale.lerpVectors(ia.minScale, this._arrowMaxScale, arrowDownAnimation.easedPhase);

    this._upArrow.position.z = this._arrowSpacing + arrowUpAnimation.easedPhase * this._arrowMovement;
    this._downArrow.position.z = -this._arrowSpacing - arrowDownAnimation.easedPhase * this._arrowMovement;

    // this._arrowMesh.scale.lerpVectors(ia.minScale, ia.maxScale, ia.easedPhase);
    // console.log('ring', delta, ia.phase, ia.easedPhase);
  }
}
